import axios from "axios";
import { getAccessToken, setTokens, clearTokens } from "./utils/authStorage";
import AuthService from "./services/AuthService";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ApiClient = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// --- Request: always attach token ---
ApiClient.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// --- Response: handle 401 once ---
ApiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // if no response, just throw error
    if (!error.response) return Promise.reject(error);

    // handle unauthorized
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // refresh tokens
        const newTokens = await AuthService.callRefreshToken(); 
        if (newTokens?.accessToken) {
          setTokens(newTokens);
          originalRequest.headers.Authorization = `Bearer ${newTokens.accessToken}`;
          return ApiClient(originalRequest); // retry once
        }
      } catch (refreshErr) {
        clearTokens();
        AuthService.logout(); // redirect to signin
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(error);
  }
);

export default ApiClient;
